import { render } from "./EditPageModal.vue?vue&type=template&id=d87220f2"
import script from "./EditPageModal.vue?vue&type=script&lang=js"
export * from "./EditPageModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__